import z from 'zod';

export enum JobType {
  QUESTION_GENERATION = 'QUESTION_GENERATION',
  SHUFFLE_QUESTIONS = 'SHUFFLE_QUESTIONS',
  VALIDATE_QUESTIONS = 'VALIDATE_QUESTIONS',
  VALIDATE_QUESTIONS_GPT = 'VALIDATE_QUESTIONS_GPT',
  STUDY_GENERATION = 'STUDY_GENERATION',
  BULK_CHANGE_QUESTION_STATUS = 'BULK_CHANGE_QUESTION_STATUS',
  SEED_QUESTION_VARIANT_GENERATION = 'SEED_QUESTION_VARIANT_GENERATION',
}

export const jobTypeSchema = z.enum(JobType);
